import { useState } from "react";

export const useFastUnlock = () => {
  const [isUnlocked, setUnlocked] = useState(
    () => localStorage.getItem("fastSwitchUnlocked") === "true"
  );

  const unlock = () => {
    localStorage.setItem("fastSwitchUnlocked", "true");
    setUnlocked(true);
  };

  const reset = () => {
    localStorage.removeItem("fastSwitchUnlocked");
    setUnlocked(false);
  };

  return { isUnlocked, unlock, reset };
};
